import ConfirmViewModel from "./confirmViewModel";

export interface ButtonParams {
  text?: string;
  /* tslint:disable:max-union-size */
  variant?:
    | "primary"
    | "secondary"
    | "light"
    | "dark"
    | "info"
    | "success"
    | "danger"
    | "outline-secondary"
    | "outline-primary"
    | "outline-danger";
  /* tslint:enable:max-union-size */
}

export default class ConfirmDialogViewModel extends ConfirmViewModel {
  constructor(
    public message: string,
    public title: string | undefined,
    public confirmButtonParams: ButtonParams,
    public cancelButtonParams: ButtonParams
  ) {
    super();
  }
}
